import Link from "next/link"
import { useTranslations } from 'next-intl';



export const FooterCTASection: React.FC = () => {
    const t = useTranslations('FooterCTA');
    
    return (
    <div className="w-full pt-10 px-4 bg-white flex justify-center">
        <div 
            className="
                mx-auto mt-28 pt-5 lg:pt-14 flex shadow-[0_5px_60px_rgba(0,0,0,0.05)]
                flex-col-reverse lg:flex-row
                text-left
                gap-24 lg:gap-0
            "
        >
            <div className="relative flex">
                <div className="mt-auto max-w-[300px] lg:max-w-[500px]">
                    <img
                        className="
                        w-full
                        opacity-0
                        animate-[fadeInUp_1s_ease_forwards_var(--animation-delay,100ms)]
                        [@keyframes_fadeInUp:'0%{opacity:0;transform:translateY(1rem);}100%{opacity:1;transform:translateY(0);}']
                        "
                        alt="background circle"
                        src="/svg/footer/circle.svg"
                    />
                </div>

                <div
                className="
                    absolute bottom-0 left-1/2 -translate-x-1/2
                    lg:left-10 lg:translate-x-0
                "
                >
                    <img
                        className="
                        max-w-[250px] lg:max-w-none
                        opacity-0
                        animate-[fadeInUp_1s_ease_forwards_var(--animation-delay,300ms)]
                        [@keyframes_fadeInUp:'0%{opacity:0;transform:translateY(1rem);}100%{opacity:1;transform:translateY(0);}']
                        "
                        alt="stay connected image"
                        src="/svg/footer/stay connected.svg"
                    />
                </div>

            </div>

            <div className="mx-0 p-5 lg:mx-20">
                <h1 className="
                mb-7 max-w-[600px] mx-auto lg:mx-0 
                font-heading-h1 font-[number:var(--heading-h1-font-weight)]
                text-x-900 text-2xl sm:text-3xl md:text-4xl lg:text-5xl 
                xl:text-[length:var(--heading-h1-font-size)]
                tracking-[var(--heading-h1-letter-spacing)]
                leading-tight md:leading-tight lg:leading-[var(--heading-h1-line-height)]
                [font-style:var(--heading-h1-font-style)]
                translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:400ms]
                ">           
                {t("title1")}
                <span className="bg-gradient-to-r from-[#08264C] to-[#3F74EF] bg-clip-text text-transparent">
                    {" "}{t("highlight")}{" "}
                </span><br />
                {t("title2")}
                </h1>

                <div className="inline-block p-[1px] rounded-sm bg-gradient-to-r from-[#08264C] to-[#3F74EF] translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:800ms]">
                <Link 
                    href="/contact"
                    className="
                    relative inline-flex items-center justify-center 
                    px-6 py-3 rounded-sm 
                    text-[#08264C]
                    bg-white
                    hover:bg-gradient-to-r hover:from-[#08264C] hover:to-[#3F74EF]
                    hover:text-white
                    transition-all duration-300
                    "
                >
                    <span className="font-space-grotesk font-bold font-black">
                    {t("CTA")}
                    </span>
                </Link>
                </div>
            </div>
        </div>
    </div>
    );
}